import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DonationForm',
  props: {
  currencies: {
    type: Object,
    default: () => ({})
  },
  symbols: {
    type: Object,
    default: () => ({})
  },
  symbol: {
    type: String,
    default: '$'
  },
  show_currency_dropdown: {
    type: Boolean,
    default: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();

const props = __props;

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt) => {
  const { exchange_rates } = lifeline_donation || {};
  const syb = getSymbol();
  if(_.get && _.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt);
  }
  return amt;
};

const formatAmount = (amount) => {
  const convertedAmount = convert(amount);
  return parseFloat(convertedAmount).toFixed(2);
};

const onCurrencyChange = () => {
  console.log('Currency changed to:', store.currency);
};

onMounted(() => {
  // Check for Zakat amount from global variable or DOM
  const zakatWrapper = document.querySelector('.lifeline-zakat-donation');
  if (zakatWrapper) {
    const zakatAmount = parseFloat(zakatWrapper.getAttribute('data-zakat-amount')) || 0;
    if (zakatAmount > 0) {
      store.amount = zakatAmount;
      console.log('Zakat amount set in Style 6:', zakatAmount);
    }
  }
  
  // Also check global variable
  if (window.lifelineZakatAmount && parseFloat(window.lifelineZakatAmount) > 0) {
    store.amount = parseFloat(window.lifelineZakatAmount);
    console.log('Zakat amount from global variable:', store.amount);
  }
  
  // Ensure this is marked as a Zakat donation
  store.extras.donation_purpose = 'Zakat';
  store.recurring = false; // Disable recurring for Zakat
});

const __returned__ = { store, props, lifeline_donation, _, getSymbol, convert, formatAmount, onCurrencyChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})